import { useNavigate } from "react-router-dom";

interface BottomNavProps {
  active: string;
  onChange: (tab: string) => void;
  onRegisterClick: () => void;
}

const tabs = [
  { id: "home", label: "בית", icon: "ri-home-5-line", iconFilled: "ri-home-5-fill" },
  { id: "search", label: "חיפוש", icon: "ri-search-line", iconFilled: "ri-search-fill" },
  { id: "activities", label: "פעילויות", icon: "ri-calendar-line", iconFilled: "ri-calendar-fill" },
  { id: "jobs", label: "משרות", icon: "ri-briefcase-line", iconFilled: "ri-briefcase-fill" },
  { id: "profile", label: "פרופיל", icon: "ri-user-line", iconFilled: "ri-user-fill" },
];

export default function BottomNav({ active, onChange, onRegisterClick }: BottomNavProps) {
  const navigate = useNavigate();

  const handleTabClick = (tabId: string) => {
    if (tabId === "home") {
      navigate("/");
      onChange(tabId);
    } else if (tabId === "activities") {
      navigate("/success-stories");
      onChange(tabId);
    } else if (tabId !== "home") {
      onRegisterClick();
    } else {
      onChange(tabId);
    }
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-gray-900"
      dir="rtl"
    >
      <div className="flex items-center justify-around px-2 py-2 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className="flex flex-col items-center gap-1 cursor-pointer transition-all"
              aria-label={tab.label}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-2xl transition-all"
                style={{
                  background: isActive ? "#EDE9FE" : "transparent",
                  transform: isActive ? "scale(1.1)" : "scale(1)",
                }}
              >
                <i
                  className={`${isActive ? tab.iconFilled : tab.icon} text-xl`}
                  style={{ color: isActive ? "#7C3AED" : "#9CA3AF" }}
                ></i>
              </div>
              <span
                className="text-[10px] font-bold whitespace-nowrap"
                style={{ color: isActive ? "#7C3AED" : "#9CA3AF" }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
